import * as z from "zod";

const req = (msg: string) =>
  z.preprocess(
    (v) => (v == null ? "" : v),
    z.string().trim().min(1, msg)
  );

export const addCustomerProductFormSchema = z.object({
  // Product
  product: req("Please choose a product."),
  billing_frequency: req("Please choose billing frequency."),

  no_of_licenses: z.preprocess(
    (val) => {
      {
        if (val === null || val === undefined || val === "") return undefined;
        const num = Number(val);
        return isNaN(num) ? val : num;
      }
    },
    z.number()
      .min(1, "Number of licenses must be at least 1.")
      .refine(val => !isNaN(val), "Please enter a valid number for licenses.")
  ),

  // plan_price_id: z.preprocess(
  //   (v) => (v == null ? 65 : Number(v)),
  //   z.number().min(1, "Please select a valid plan.")
  // ),

  // Payment
  total_paid_amount: z.preprocess(
    (val) => {
      if (val === null || val === undefined || val === "") return undefined;
      const num = Number(val);
      return isNaN(num) ? val : num;
    },
    z.number()
      .min(0, "Total amount must be a positive number.")
      .refine(val => val > 0, "Total amount must be greater than zero.")
  ),

  discount: z.preprocess(
    (val) => {
      if (val === null || val === undefined || val === "") return undefined;
      const num = Number(val);
      return isNaN(num) ? val : num;
    },
    z.number()
      .min(0, "Discount must be a positive number.")
      .refine(val => !isNaN(val), "Please enter a valid discount amount.")
      .optional()
  ),

  payment_mode: req("Please choose payment mode."),
  transaction_ref: z.string().optional(),
  date_of_payment: req("Please select date of payment."),
});


export type AddCustomerProductFormValues = z.infer<typeof addCustomerProductFormSchema>;